import type { MessageDescriptor } from '@lingui/core';
import { describeApplicationSaveError } from 'modules/teams/domain/utils/application-save-error';
import { toast } from 'react-toastify';

/** Тост отказа сохранения заявок; повтор запроса (код 15) не показывается — см. `describeApplicationSaveError`. */
export function toastApplicationSaveError(error: unknown, title: MessageDescriptor): void {
  const text = describeApplicationSaveError(error, title);
  if (text) toast.error(text);
}
